import BaseComponent from '../abstracts/BaseComponent';

export default class CountrySelectorComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.handleChange();
  }

  handleChange() {
    this.$on('change.state', (e) => {
      this.EMIT(this.CUSTOM_MESSAGES.COUNTRY_SELECTOR_EVENTS.change, {
        countryCode: e.currentTarget.value
      });
    });
  }
}
